let load = require('./helpers/browser/esm-js-loader-shards')(5);
module.exports = Promise.all([load("aodp5"), load("6zHfc"), load("dMWJp")]).then(() => parcelRequire('eTW2b'));